<template>
<div class="mx-3">
    <v-row no-gutters>
        <v-col cols="6">
            <div class="important">
                Service
            </div>
            <div class="regular">
                {{ item.service }}
            </div>
        </v-col>

        <v-col cols="6">
            <div class="important">
                Slug
            </div>
            <div class="regular">
                {{ item.slug }}
            </div>
        </v-col>

        <v-col cols="12" class="my-3">
            <div class="important">
                Listeners
            </div>
            <v-row no-gutters>
                <v-chip class="ma-1" v-for="(id, index) in item.listeners" :key="index">
                    {{filteredListeners(id)}}
                </v-chip>
            </v-row>
        </v-col>
    </v-row>
</div>
</template>

<script>
import defaults from "../utils/PropDefaults.js"

export default {
    props: {
        item: {
            type: Object,
            default: defaults.event_item
        },
        listeners: Array,
    },
    methods: {

        emitClick() {
            this.$emit('click');
        },

        filteredListeners: function (id) {
            let listeners = this.listeners.filter((item) => {
                if(item.value === id) return item;
            });
            return listeners.length > 0 ? listeners[0].text : null;
        }
    }
}
</script>
